import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./Components/HomePage";
import AboutPage from "./Components/AboutPage";
import ContactPage from "./Components/ContactPage";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import ReferencesPage from "./Components/ReferencesPage";
import ReferenceDetailPage from "./Components/ReferenceDetailPage";
import MailPage from "./Components/MailPage";
import NotFoundPage from "./Components/Notfoundpage";
import PrivacyPolicy from "./Components/Confidentialite";
import TermsOfService from "./Components/ConditionsUtilisation";
import { HelmetProvider } from "react-helmet-async";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/apropos" element={<AboutPage />} />
          <Route path="/metier" element={<ContactPage />} />
          <Route path="/references" element={<ReferencesPage />} />
          <Route path="/reference/:id" element={<ReferenceDetailPage />} />
          <Route path="/contact" element={<MailPage />} />
          <Route
            path="/conditions-generales-utilisation"
            element={<TermsOfService />}
          />
          <Route
            path="/politique-de-confidentialite"
            element={<PrivacyPolicy />}
          />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
      </Router>
    </HelmetProvider>
  );
}

export default App;
